<script lang="ts" setup>
  import ButtonQC from '@qicgroupdoha/qic-connect-ds/components/ButtonQC'
  import WrapperQC from '@qicgroupdoha/qic-connect-ds/components/WrapperQC'
  interface Emits {
    (e: 'delete', status: boolean): void
  }
  interface Props {
    srNo: string
  }
  defineProps<Props>()
  const emit = defineEmits<Emits>()
</script>

<template>
  <WrapperQC
    direction="column"
    padding="var(--spacing-7)"
    gap="var(--spacing-7)"
    class="delete-modal-qc"
  >
    <h6 class="heading-6 text-center">
      {{ $t('inbound_travelers_delete_header') }}
    </h6>
    <WrapperQC gap="var(--spacing-4)" class="delete-modal-qc__buttons">
      <ButtonQC
        size="medium"
        wide
        :data-test="`delete-modal-cancel-button-${srNo}`"
        @click="emit('delete', false)"
      >
        {{ $t('inbound_travelers_delete_cancel_button') }}
      </ButtonQC>
      <ButtonQC
        variant="outline"
        wide
        size="medium"
        :data-test="`delete-modal-accept-button-${srNo}`"
        @click="emit('delete', true)"
      >
        {{ $t('inbound_travelers_delete_accept_button') }}
      </ButtonQC>
    </WrapperQC>
  </WrapperQC>
</template>

<style lang="scss" scoped>
  .delete-modal-qc {
    border-radius: var(--radius-6);
    background: var(--colorBgSrfSecondary);
    margin-bottom: var(--spacing-6);
  }
</style>
